import { render, staticRenderFns } from "./file-drop.vue?vue&type=template&id=0a9f3468&"
import script from "./file-drop.vue?vue&type=script&lang=js&"
export * from "./file-drop.vue?vue&type=script&lang=js&"
import style0 from "./file-drop.vue?vue&type=style&index=0&id=0a9f3468&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports